<template>
  <div class="content">
    <div style="height: .88rem;line-height: .88rem;background-color: #fff;width: 100%">
      <span style="padding-left: .4rem">{{name}}</span>
      <span style="float: right;color: red;padding-right: .4rem">总金额：￥{{amount}}</span>
    </div>
    <div v-if="payList.length>0">
      <el-table :data="payList" style="width: 100%" border :header-cell-style="{background:'#87CEFA',color:'#fff'}">
        <el-table-column prop="项目名称" label="项目名称" width="140" align="center"></el-table-column>
        <el-table-column prop="单位" label="单位" min-width="20" align="center"></el-table-column>
        <el-table-column prop="数量" label="数量" min-width="20" align="center"></el-table-column>
        <el-table-column prop="单价" label="单价" min-width="20" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="noCard" v-if="!payList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无缴费内容</div>
    </div>
  </div>
</template>

<script>
  import {GetFeeInfo} from '../../api/index'
    export default {
      data(){
        return{
          payList:[],
          name:'',
          amount:0,
        }
      },
      created() {
        //修改标题
        document.title = '缴费记录详情'
        GetFeeInfo({
          order_id:this.$route.query.id
        }).then(res=>{
          this.payList = res.Data.FeeList
          this.name = res.Data.ClinicOrder.clinic_patient_name
          this.amount = res.Data.FeeList[0].总金额
        })
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/payRecordDetails.vue